'use strict';

module.exports = /* @ngInject */ function (apiConfig, sseService, httpService) {

    function getBase() {
        return `${apiConfig.$get().apiUrl}/order`
    }

    function getCustomerCompanyIdByOrderNumber(orderNumber) {
        const url = `${getBase()}/${orderNumber}/customer`;
        return httpService.get(url, {
            transformResponse: function (data) {
                return {
                    id: data
                }
            },
            cache: true
        });
    }

    function findById(orderNumber) {
        const url = `${getBase()}/${orderNumber}`;
        return httpService.get(url);
    }

    return {
        findById,
        getCustomerCompanyIdByOrderNumber,
    }
}
